import React, {useState, useEffect, useRef} from 'react'
import DataView from '../../../../UI/Dashboard/DataView'
import Ajax from '../../../../../helpers/Ajax'
import { useParams } from 'react-router-dom'
import FormGroup from '../../../../UI/Form/FormGroup'
import ErrorField from '../../../../UI/Form/ErrorField'
import { Formik, Field, Form, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import DataLoader from '../../../../UI/Dashboard/DataLoader'
import Button from '../../../../UI/Form/Button'
import ContentLayout from '../../../../Common/ContentLayout'
import { toast } from 'react-toastify'
import { Helmet } from 'react-helmet-async'
import GetProduct from '../../../../../helpers/GetProduct'

export default function AmenityDetail() {
    const [infoDetail, setInfoDetail] = useState(null)
    const [productList, setProductList] = useState(null)
    const urlParams = useParams()
    const dataIcon = useRef()
    useEffect(()=>{
        const getResponse = setTimeout(function(){
            (async()=>{
              const response = await Ajax({
                url: `/product/nearby?_id=${urlParams.NearbyId}`,
                token: true
              })
              if(response.data.status === "SUCCESS!"){
                setInfoDetail(response.data.result[0])
              }

              const getProductList = await GetProduct();
              setProductList(getProductList);

           
            })()
          },100)    
        
         
          return()=>{
            clearInterval(getResponse)
          }
    },[])

    const updateProcess = async (values, event) => {
        const formData = new FormData()
        if(dataIcon.current.value != ''){
            formData.append("file", dataIcon.current.files[0])
        }
        const data = {
            name: values.nearby_title, 
            productId:values.productId,
            sortOrder:values.sortOrder,
            active: values.active == 1 ? true : false, 
        }
        for(var key in data) {
            if(data[key] !== "") {
                formData.append(key, data[key])
            }
        }
        const update = await Ajax({
            url: `/product/nearby/${urlParams.NearbyId}`,
            method: 'PUT',
            token: true,
            data: formData,
            loader: true
        })
        if(update.error){
            toast.error('Something Went Wrong Please Check')
        }
        if(update.data.status === "SUCCESS!"){
            toast.success('Content Updated Successfully')
            setTimeout(function(){
                window.location.reload()
            },500)
        }
    }
    return (
        <ContentLayout title="Edit Nearby Infra">
            <Helmet>
                <title>Edit Nearby Infra</title>
            </Helmet>
            <DataView title="Infomation">
              
            {infoDetail === null  || productList === null ? <DataLoader/> : 
                <Formik
               
                    initialValues={{ 
                        nearby_title: infoDetail.name ? infoDetail.name : '', 
                        productId: infoDetail.productId ? infoDetail.productId._id : '', 
                        sortOrder: infoDetail.sortOrder ? infoDetail.sortOrder : '', 
                        active: infoDetail.active === true ? 1 : 2
                    }}
                    validationSchema={Yup.object({
                        nearby_title: Yup.string()
                        .required('Field is Required'),
                        productId: Yup.string()
                        .required('Field is Required'),
                        sortOrder: Yup.number()
                        .required('Field is Required'),
                        active: Yup.string()
                        .required('Field is Required')
                    })}
                    onSubmit={(values, event) => {
                        updateProcess(values, event)
                    }}
                >
                <Form>
                    <div className='row'> 
                    <div className='col-md-4'>
                    <FormGroup label="Property Name" required>
                        <Field as="select" name="productId" className='form-select'>
                        {productList === null? <option value='' disabled>Searching...</option> :  productList.map(e=>(
                                <option key={e._id} value={e._id}>{e.name+' ('+e.unitNumber+')'}</option>
                           ))}
                        </Field>
                        <ErrorField><ErrorMessage name="productId"/></ErrorField>
                    </FormGroup>
                    </div>
                        <div className='col-md-4'>
                            <FormGroup label="Nearby Infra Title" required>
                                <Field placeholder='Nearby Infra Title' name="nearby_title" className='form-control' />
                                <ErrorField><ErrorMessage name="nearby_title"/></ErrorField>
                            </FormGroup>
                        </div>
                        <div className='col-md-4'>
                            <FormGroup label="Sort Order" required>
                                <Field placeholder='Sort Order' name="sortOrder" type="number" className='form-control' />
                                <ErrorField><ErrorMessage name="sortOrder"/></ErrorField>
                            </FormGroup>
                        </div>
                        <div className='col-md-4'>
                            <FormGroup label="Amenity Image" required>
                                <input type="file" accept='.jpg, .png, jpeg, .webp' name="amenity_image" ref={dataIcon} className='form-control' />
                            </FormGroup>
                        </div>
                        <div className='col-md-2'>
                            {infoDetail.file && 
                            <FormGroup label="Preview">
                                <img src={infoDetail.file.path} alt="prcess icon" width="80px" className='img-fluid' /> 
                            </FormGroup>}
                        </div>
                    </div>
                    <FormGroup label="Active" required>
                        <Field as="select" name="active" className='form-select'>
                            <option value="1">Enable</option>
                            <option value="2">Disable</option>
                        </Field>
                        <ErrorField><ErrorMessage name="type"/></ErrorField>
                    </FormGroup>
                    <div className='col-md-2 d-grid'>
                        <Button type="submit">Update</Button>
                    </div>
                </Form>
                </Formik> }
            </DataView>
        </ContentLayout>
    )
}
